// AssetStatus 资源状态
export enum AssetStatus {
  Pending = 'pending', // 待上传
  Transcoding = 'transcoding', // 转码中
  Active = 'active', // 可用
  Error = 'error', // 出错
}
